module.exports = __webpack_public_path__ + "img/d7.ccdda1c2.jpg";